(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-shopping-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const track = root.querySelector('[data-carousel-track]');
      const slides = [...root.querySelectorAll('[data-carousel-slide]')];
      const previous = root.querySelector('[data-carousel-previous]');
      const next = root.querySelector('[data-carousel-next]');
      if (!track || slides.length < 2 || track.dataset.initialized) return;
      track.dataset.initialized = 'true';
      const list = track.querySelector('[data-carousel-list]');
      const clones = [];
      let index = 0;
      let step = 0;
      let paused = false;
      const measure = () => {
        const gap = parseFloat(getComputedStyle(list).gap) || 0;
        step = slides[0].getBoundingClientRect().width + gap;
        while (clones.length) clones.pop().remove();
        if (!step) return;
        while (track.scrollWidth < root.querySelector('[data-carousel-viewport]').clientWidth + list.getBoundingClientRect().width) {
          const clone = list.cloneNode(true);
          clone.removeAttribute('data-carousel-list');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('button, a').forEach((item) => { item.tabIndex = -1; });
          track.append(clone);
          clones.push(clone);
        }
        track.style.transform = `translateX(-${index * step}px)`;
      };
      const move = (direction) => {
        if (!step) return;
        paused = true;
        index += direction;
        if (index < 0) index = slides.length - 1;
        track.style.transition = 'transform .45s ease';
        track.style.transform = `translateX(-${index * step}px)`;
        window.setTimeout(() => {
          if (index >= slides.length) {
            index = 0;
            track.style.transition = 'none';
            track.style.transform = 'translateX(0)';
            track.offsetHeight;
            track.style.transition = '';
          }
          paused = false;
        }, 460);
      };
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      root.querySelector('[data-carousel-viewport]')?.addEventListener('mouseenter', () => { paused = true; });
      root.querySelector('[data-carousel-viewport]')?.addEventListener('mouseleave', () => { paused = false; });
      root.addEventListener('focusin', () => { paused = true; });
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) paused = false; });
      window.addEventListener('resize', measure);
      measure();
      const interval = Math.max(1000, Number(root.dataset.autoplayInterval) * 1000 || 2000);
      window.setInterval(() => {
        if (!paused && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) move(1);
      }, interval);
    };
    document.querySelectorAll('[data-video-shopping-carousel]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => { const root = event.target.querySelector('[data-video-shopping-carousel]'); if (root) init(root); });
  })();

  } catch(e) { console.error(e); }
})();
})();
